import React, { useEffect, useState } from 'react'
import { addproduct, deleteproductimage, listcategory,  updateproduct, viewproducts } from "../../service/dataservice";
import { toast } from "react-toastify";
import dataservice from '../../service/dataservice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../loader';
import imageCompression from "browser-image-compression";

export const Addproduct = () => {
  const { id } = useParams();
  const loc = useLocation(); const nav = useNavigate();
  const [loader, setloader] = useState(false);
  let [ProductDet, setProductDet] = useState({
    product_name: "",
    product_category_id: 0,
    user_id: localStorage.getItem("user_id"),
    product_images: [],
  });
  let [Categorytype_list, setCategorytype_list] = useState([]);
  useEffect(() => {

    listcategory().then((res) => {
      if (res.status) {
        setCategorytype_list(res.data);
      }
      else toast.error(res.message);
    })
      .catch((err) => toast.error(err.message));



    if (id) { handleAlter() }
  }, [])

  const handleAlter = () => {
    setloader(true);
    viewproducts(id).then((res) => {
      if (res.status) {
        const data = res.data;
        setProductDet({
          ...data,
          product_images: data.product_images || [],
        });
        setloader(false);
      }
      else {
        toast.error(res.message);
        setloader(false);
      }
    })
      .catch((err) => {
        setloader(false);
        toast.error(err.message);
      })
  }
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setProductDet((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const validate = () => {
    // if (!ProductDet.product_name) {
    //   toast.error('Product name is required'); return false;
    // }
   
    if (!ProductDet.product_category_id) {
      toast.error('Category is required'); return false;
    }
   
    if (!ProductDet.product_images) {
      toast.error('Product image is required'); return false;
    }
    return true;
  }

  const compressImage = async (file) => {
    if (!file) return null;

    const options = {
      maxSizeMB: 0.5, // 500 KB
      useWebWorker: true,
      initialQuality: 0.8,
    };

    try {
      // 1. Compress image
      let compressedFile = await imageCompression(file, options);

      // 2. Optional second pass if still > 500KB
      if (compressedFile.size / 1024 > 500) {
        compressedFile = await imageCompression(compressedFile, {
          ...options,
          initialQuality: 0.6,
        });
      }

      // 3. Extract original extension
      const originalName = file.name || "image.jpg";
      const ext = originalName.substring(originalName.lastIndexOf("."));

      // 4. Ensure valid extension fallback
      const safeExt = ext && ext.includes(".") ? ext : ".jpg";

      // 5. Create proper filename
      const newFileName = `${Date.now()}_${Math.random()
        .toString(36)
        .substring(2)}${safeExt}`;

      // 6. Return proper File object (IMPORTANT)
      return new File([compressedFile], newFileName, {
        type: file.type || "image/jpeg",
      });
    } catch (err) {
      console.error("Compression error:", err);

      // fallback with correct filename
      const originalName = file.name || "image.jpg";
      const ext = originalName.substring(originalName.lastIndexOf("."));
      const safeExt = ext && ext.includes(".") ? ext : ".jpg";

      const newFileName = `${Date.now()}_${Math.random()
        .toString(36)
        .substring(2)}${safeExt}`;

      return new File([file], newFileName, {
        type: file.type || "image/jpeg",
      });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setloader(true);
    if (!validate()) {
      setloader(false);
      return;
    }

    try {
      let data = new FormData();
      Object.entries(ProductDet).forEach(([key, value]) => {
        if (key === "product_images") return;
        data.append(key, value ?? "");
      });

      // 3. Append the Image Files (THE FIX)
      // if (
      //   Array.isArray(ProductDet.product_images) &&
      //   ProductDet.product_images.length > 0
      // ) {
      //   const compressedImages = await Promise.all(
      //     ProductDet.product_images.map((file) => compressImage(file))
      //   );

      //   compressedImages.forEach((file) => {
      //     data.append("product_images[]", file);
      //   });
      // }
      const newFiles = Array.isArray(ProductDet.product_images)
        ? ProductDet.product_images.filter((file) => file instanceof File)
        : [];

      if (newFiles.length > 0) {
        const compressedImages = await Promise.all(
          newFiles.map((file) => compressImage(file))
        );

        compressedImages.forEach((file) => {
          data.append("product_images[]", file);
        });
      }
      let apiname = id ? updateproduct : addproduct;
      apiname(data).then((res) => {
        if (res.status) {
          setProductDet({})
          window.location.reload();
          setloader(false);
        }
        else { toast.error(res.message); setloader(false); }
      })
        .catch((err) => {
          setloader(false);
          toast.error(err.message)
        });
    }
    catch (err) {
      setloader(false);
    }

  }

  function photofile(event) {
    const validFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      if (event.target.files.length !== 0) {
        if (event.target.files[i].name.match(/\.(jpg|jpeg|png)$/i)) {
          var size = event.target.files[i].size / 1024 / 1024;
          if (size > 3) {
            toast.error(event.target.files[i].name + " size should be less than 3MB")
          } else {
            validFiles.push(event.target.files[i]);
          }
        } else {
          toast.error(event.target.files[i].name + " should be jpg or jpeg or png format")
        }
      }
    }
    setProductDet((prev) => ({
      ...prev,
      product_images: [...(Array.isArray(prev.product_images) ? prev.product_images : []), ...validFiles],
    }));
  }

  // ✅ remove file
  const handleRemoveFile = (index) => {
    if (id) {
      let data = new FormData();
      data.append("product_id", id);
      data.append("image_url", ProductDet.product_images[index]);
      deleteproductimage(data).then((res) => {
        if (res.status) {
          setProductDet((prev) => {
            const updatedFiles = [...prev.product_images];
            updatedFiles.splice(index, 1);
            return { ...prev, product_images: updatedFiles };
          });
        }
        else toast.error(res.message);
      })
        .catch((err) => toast.error(err.message));

    } else {
      setProductDet((prev) => {
        const updatedFiles = [...prev.product_images];
        updatedFiles.splice(index, 1);
        return { ...prev, product_images: updatedFiles };
      });
    }


  };

  return (

    <div>
      {loader && <Loader />}
      <div className="page-title mb-4">
        <div className="row g-2 align-items-center">
          <div className="col-sm-6">
            <h4>Add Product</h4>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <form className="theme-form" onSubmit={handleSave}>

                  {/* PRODUCT NAME */}
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Product Name 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="product_name"
                          value={ProductDet.product_name}
                          onChange={handleChange}
                          placeholder="Enter Product name"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Category <span className="text-danger">*</span></label>
                        <select
                          className="form-select"
                          name="product_category_id"
                          value={ProductDet.product_category_id}
                          onChange={handleChange}
                        >
                          <option value="">-- Select --</option>
                          {Categorytype_list?.map((x) => (
                            <option value={x.id} key={x.id}>{x.category_name}</option>
                          ))}
                        </select>
                      </div>
                    </div>


                    <div className="col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Upload Product Images <span className="text-danger">*</span></label>
                        <input
                          className="form-control"
                          type="file"
                          name="product_images"
                          multiple
                          accept=".jpg,.jpeg,.png"
                          onChange={photofile}
                        />
                      </div>
                    </div>
                  </div>



                  {/* PREVIEW IMAGES */}
                  <div className="row mt-3">
                    {ProductDet.product_images?.length > 0 ? (
                      ProductDet.product_images.map((file, index) => (
                        <div key={index} className="col-md-3 col-6 mb-3">
                          <div className="position-relative">
                            <img
                              src={file instanceof File ? URL.createObjectURL(file) : file}
                              alt={file.name || `image-${index}`}
                              className="img-fluid rounded border"
                              style={{ height: "150px", objectFit: "cover" }}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0"
                              onClick={() => handleRemoveFile(index)}
                            >
                              ✕
                            </button>
                          </div>
                          <small className="d-block text-truncate mt-1">
                            {file.name || file.split('/').pop()}
                          </small>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No images selected</p>
                    )}
                  </div>

                  {/* BUTTON */}
                  <div className="row">
                    <div className="col text-end">
                      <button type="button" className="btn btn-secondary me-2 mt-4" onClick={() => nav("/product/productlist")}>
                        Back
                      </button>
                      <button type="submit" className="btn btn-success mt-4">
                        {id ? "Update" : "Add"} Product
                      </button>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
